import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFill = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 25,
	height: 25,
	viewBox: "0 0 25 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M9.85922 12.2169L1.77344 20.3027L4.60186 23.1312L12.6877 15.0454L20.7734 23.1312L23.6019 20.3027L15.5161 12.2169L23.6019 4.13116L20.7734 1.30273L12.6877 9.38852L4.60186 1.30273L1.77344 4.13116L9.85922 12.2169Z",
		fill: "#395566"
	})
});
export default SvgFill;
